export const MEMBERSHIP_OFFERING_PRICE_CHOICES = {
  ACTUAL_PRICE: "actual_price",
  AT_DISCOUNTED_PRICE: "at_discounted_price",
  FREE_OF_COST: "free_of_cost",
  NOT_INCLUDED: "not_included",
};

export const OFFERING_MEMBERSHIP_PRICE_FIELD_KEYS = {
  selectedValue: "selectedValue",
  linkToParentSubscription: "linkToParentSubscription",
  discountedPrice: "discountedPrice",
  enableInternationalPrice: "enableInternationalPrice",
  internationalPrice: "internationalPrice",
};
